module.exports = __webpack_public_path__ + "img/wish_01.2bca91a2.png";